import React, { useState, useEffect, useContext } from 'react';
import './index.css'
import CarHeader from '../../components/Headers/CarHeader';
import BadgeStatus from '../../components/BadgeStatus';
import ServiceStatus from '../../components/ServiceStatus';
import ServiceHistory from '../../components/ServiceHistory';
import BannerHeader from '../../components/Headers/BannerHeader';
import { getModelData, filterCarData, getVehiclesUser } from '../../services/HomeService';
import Loading from '../../components/Loading';
import { isValidModelYear } from '../../services/utils';
import Review from '../../components/Review';

const chooseModel = async (props, setModel, selectedVin) => {
  let selectedModel = props.location.state.garage.find(filtered => filtered.vin === selectedVin)
  try {
      setModel({data: null,modelDetails: null,  isFetching: true});
      const response = await  getModelData(filterCarData(props.location.state.garage, selectedVin));
      setModel({data: response, modelDetails: selectedModel, isFetching: false});
      
  } catch (e) {
      setModel({data: null, modelDetails: null, isFetching: false});
  }
};

const PageHome = (props) => {  
  const [selectedModel, setModel] = useState(null)
  useEffect(() => {
    async function fetch() {
      try {
        if(props && props.location.state) {
          let nextVin = props.location.state.selectedVin ? props.location.state.selectedVin : props.location.state.garage[props.location.state.garage.length - 1].vin
          if(!(selectedModel && selectedModel.modelDetails && selectedModel.modelDetails.vin !== nextVin && selectedModel.modelDetails.purchaseDate && selectedModel.modelDetails.lastOdometer)) {
            await chooseModel(props, setModel, nextVin);
            
          }


        } else {
          props.history.push('/login') 
        }
      } catch (error) {
          console.error(error)
          props.history.push('/login')

      }      
    }
    

    fetch()
      
  }, [])

  let isModelYearSmall2020 = selectedModel

  let reverse = []
  if(selectedModel && selectedModel.data) {
    reverse = [...selectedModel.data.vehicleServicingHistory].reverse()
  }

    return (
      <div>
        <BannerHeader/>
        <CarHeader 
          history={props.history}
          userData={props.location.state ? props.location.state.user : []}
          selectedModel={selectedModel }
          garageList={props.location.state ? props.location.state.garage.filter(filtered => filtered.mileage).reverse() : []}
          selectModel={(vin) => {
            
            if(vin !== selectedModel.data.vin) {
              chooseModel(props, setModel, vin);
            }
          }}
        />
        { selectedModel && (selectedModel.data || selectedModel.modelDetails) &&
          isValidModelYear(selectedModel.modelDetails.modelYear) &&
          <div>
            <BadgeStatus
              modelDetail={selectedModel.modelDetails ? selectedModel.modelDetails : null}
              km_actual={ selectedModel.modelDetails.mileage > selectedModel.data.lastOdometer ?  selectedModel.modelDetails.mileage : selectedModel.data.lastOdometer}
              isStampActive={selectedModel.isStampActive}
              isValidYear={selectedModel.modelDetails.modelYear >= 2020}
              warranty={selectedModel.data.warranty}
            />
            { selectedModel && selectedModel.modelDetails && 
              isValidModelYear(selectedModel.modelDetails.modelYear) &&
              <div>
                <Review
                  selectedModel={selectedModel.modelDetails}
                  serviceList={reverse}
                  nextRevisionDate={selectedModel.data.nextRevisionDate}
                  nextRevisionOdometer={selectedModel.data.nextRevisionOdometer}
                  nextRevisionNumber={selectedModel.data.vehicleServicingHistory.length + 1}
                  completeData={selectedModel.data}
                />                
              </div>
            }
          </div>
        }
        <Loading modalShow={selectedModel && selectedModel.isFetching}/>
      </div>
    )
}

export default PageHome
